export default __webpack_public_path__ + "static/media/Banner.26151c6c.png";